import { DIV, NodeOrOptional, NODISPLAY } from 'sdi/components/elements';
import {
    renderCriticality,
    renderIssueDate,
    renderIssueInfo,
    renderStatus,
} from './issue-info';
import {
    renderButtonCollapse,
    renderButtonDeselect,
    renderButtonExpand,
} from '../buttons';
import { renderLegendSwitch, renderLegendBody } from './legend';
import tr from 'sdi/locale';
import { getSelectedIssues } from 'qa/src/queries/table';
import { getCollapsible } from 'qa/src/queries/app';
import { Issue } from 'qa/src/remote';
import { setCollapsible } from 'qa/src/events/app';
import {
    renderDurationSelect,
    renderGlobalInfoOpt,
    //     renderGlobalNoteOpt,
} from './global-info';
import { deselectIssue } from 'qa/src/events/qa';

// export const noView = () => DIV({ className: 'sidebar-main feature-view no' });
export const noView = () => DIV({});

export type ExCo = [() => void, () => void];

const renderTitle = (...title: NodeOrOptional[]) =>
    DIV({ className: 'sidebar-item__title' }, ...title);
const renderIssueId = (...id: NodeOrOptional[]) =>
    DIV({ className: 'issue__id' }, ...id);

const getName = (name: string | [string, string]) =>
    Array.isArray(name) ? name[0] : name;
const getClassName = (name: string | [string, string]) =>
    Array.isArray(name) ? name[1] : name;

// Default wrapper for global-info, legend
const renderWrapper = (
    name: string | [string, string],
    header: NodeOrOptional | NodeOrOptional[],
    body: NodeOrOptional | NodeOrOptional[],
    [onExpand, onCollapse] = [() => {}, () => {}] as ExCo
) =>
    DIV(
        { className: `sidebar-item ${getClassName(name)} active` },
        DIV(
            { className: 'sidebar-item__header' },
            header,
            getCollapsible(getName(name))
                ? renderButtonCollapse(() => {
                      setCollapsible(getName(name), false);
                      onCollapse();
                  })
                : renderButtonExpand(() => {
                      setCollapsible(getName(name), true);
                      onExpand();
                  })
        ),
        getCollapsible(getName(name))
            ? DIV({ className: 'sidebar-item__body' }, body)
            : NODISPLAY()
    );

// Default wrapper for issue
const renderIssueWrapper = (
    name: string | [string, string],
    header: NodeOrOptional | NodeOrOptional[],
    body: NodeOrOptional | NodeOrOptional[],
    issue: Issue,
    [onExpand, onCollapse] = [() => {}, () => {}] as ExCo
) =>
    DIV(
        { className: `sidebar-item ${getClassName(name)} active` },
        DIV(
            { className: `sidebar-item__header ${issue.criticity}` },
            header,
            DIV(
                { className: 'issue-header__actions' },
                renderButtonDeselect(() => deselectIssue(issue)),
                getCollapsible(getName(name))
                    ? renderButtonCollapse(() => {
                          setCollapsible(getName(name), false);
                          onCollapse();
                      })
                    : renderButtonExpand(() => {
                          setCollapsible(getName(name), true);
                          onExpand();
                      })
            )
        ),
        getCollapsible(getName(name))
            ? DIV({ className: 'sidebar-item__body' }, body)
            : NODISPLAY()
    );

const renderIssueNameWrapper = (issue: Issue) =>
    DIV(
        { className: 'issue__name-wrapper' },
        renderIssueId(`${issue.id}`),
        renderIssueDate(issue)
    );

// FIX ME
const renderIssue = (issue: Issue) =>
    renderIssueWrapper(
        [`issue-${issue.id}`, 'issue'],
        [
            renderIssueNameWrapper(issue),
            renderStatus(issue),
            renderCriticality(issue),
        ],
        renderIssueInfo(issue),
        issue
    );

const renderGlobalInfo = (body: NodeOrOptional) =>
    renderWrapper(
        'global-info',
        renderTitle(tr.qa('keyNumbers'), renderDurationSelect()),
        body
    );

const renderLegend = () =>
    renderWrapper(
        'legend',
        renderTitle(tr.qa('legend'), renderLegendSwitch()),
        renderLegendBody()
    );

// const renderGlobalNote = (body: NodeOrOptional) =>
//     renderWrapper('global-note', tr.qa('notes'), body);

const renderDefaultSidebar = () =>
    DIV(
        { className: 'sidebar sidebar-right' },
        renderGlobalInfoOpt().map(renderGlobalInfo),
        // renderGlobalNoteOpt().map(renderGlobalNote),
        getSelectedIssues().reverse().map(renderIssue),
        renderLegend()
    );

export const renderIndexSidebar = renderDefaultSidebar;
